import { map } from 'rxjs/operators';
import { ReportRecord } from '../../../../../models/report.model';
import { LovValues } from '../../../../../models/template.model';
import { displayFnWrapper, mapAndFormatDynamicValue } from '../../../utils/dynamic-data-retrievers';
import { currencyLov, PropertyType, valueWithUomPrefix } from '../../us/us.common';

export const displayFnMap = {
  373: {
    // 373 - status
    // clear
    displayFn: (record: ReportRecord, _, status) => {
      return status.lovValues.pipe(
        map((lovs: LovValues[]) => {
          const lovKeyValue = mapAndFormatDynamicValue(record, status, lovs);
          const lovValue = lovs.find(a => a.key === lovKeyValue);
          return lovValue ? lovValue.value : '';
        })
      );
    },
  },
  374: {
    // 374 - year built
    // clear
    displayFn: (record: ReportRecord, options, yearBuilt) => {
      const value = displayFnWrapper(record, options, yearBuilt);
      return Array.isArray(value) ? value.join(', ') : value;
    },
  },
  375: {
    // 375 - Class
    // clear
    displayFn: (record: ReportRecord, _, classArg) => {
      return classArg.lovValues.pipe(
        map((lovs: LovValues[]) => {
          const lovKeyValue = mapAndFormatDynamicValue(record, classArg, lovs);
          const lovValue = lovs.find(a => a.key === lovKeyValue);
          return lovValue ? lovValue.value : '-';
        })
      );
    },
  },
  437: {
    // 437 - date available
    // clear
    displayFn: displayFnWrapper,
  },
  376: {
    // 376 - Average Direct Asking Rate Yearly
    // clear
    displayFn: (record: ReportRecord, options, askingRateYearly) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const value = valueWithUomPrefix(record, PropertyType.Office, askingRateYearly, currencyLOV);
          return Array.isArray(value) ? value.join(', ') : value;
        })
      );
    },
  },
  378: {
    // 378 - Service Charge
    // clear
    displayFn: (record: ReportRecord, options, serviceCharge) => {
      return currencyLov(options).pipe(
        map((currencyLOV: LovValues[]) => {
          const value = valueWithUomPrefix(record, PropertyType.Office, serviceCharge, currencyLOV);
          return Array.isArray(value) ? value.join(', ') : value;
        })
      );
    },
  },
  371: {
    // 371 - description
    // TODO: BE needs to support colloquial and not colloquial (currently only sending colloquial)
    displayFn: displayFnWrapper,
  },
  436: {
    // 436 - location transport
    // clear
    displayFn: displayFnWrapper,
  },
  386: {
    // 386 - Floor Label
    // clear
    displayFn: displayFnWrapper,
  },
  387: {
    // 387 - Usage Label
    // clear
    displayFn: displayFnWrapper,
  },
  388: {
    // 388 - Sqm label
    // clear
    displayFn: displayFnWrapper,
  },
  389: {
    // 389 - Available Label
    // clear
    displayFn: displayFnWrapper,
  },
  372: {
    // 372 - Location/Transit (description)
    displayFn: (record: ReportRecord, _, locationDescriptionArg) => {
      const charLimit = 190;
      const descriptionValue: string = (mapAndFormatDynamicValue(record, locationDescriptionArg) as string) || '-';
      return descriptionValue.substring(0, charLimit);
    },
  },
  380: {
    // 380 - Parking Space
    displayFn: displayFnWrapper,
  },
};
